export default "__VITE_ASSET__B_1MeK4Y__"